/* storybook-check-ignore */
const MenuClose = ({ size = '24px' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7701 17.5501C20.0766 17.2436 20.0766 16.7466 19.7701 16.4401L15.33 12L19.7701 7.55994C20.0766 7.25342 20.0766 6.75645 19.7701 6.44992L17.5501 4.22989C17.2436 3.92337 16.7466 3.92337 16.4401 4.22989L12 8.66996L7.55994 4.22989C7.25342 3.92337 6.75645 3.92337 6.44992 4.22989L4.22989 6.44992C3.92337 6.75644 3.92337 7.25342 4.22989 7.55994L8.66995 12L4.2299 16.4401C3.92338 16.7466 3.92337 17.2436 4.2299 17.5501L6.44993 19.7701C6.75645 20.0766 7.25342 20.0766 7.55994 19.7701L12 15.33L16.4401 19.7701C16.7466 20.0766 17.2435 20.0766 17.5501 19.7701L19.7701 17.5501Z"
        fill="var(--colors-neutrals100)"
      />
    </svg>
  );
};

export default MenuClose;
